import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalBody,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const RulesRemarkModal = ({ content, isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onOverlayClick={onClose}
      isCentered
      autoFocus={false}
    >
      <ModalOverlay />
      <ModalContent
        bgColor="primary.500"
        borderRadius="6px"
        w="600px"
        maxW="calc(100vw - 20px)"
        className="member-center-rules-remark-modal__content"
      >
        <ModalHeader>{t('member_points.rule')}</ModalHeader>
        <ModalBody
          variant="default"
          className="member-center-rules-remark-modal__body"
        >
          {content}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="default" autoFocus={false}>
            {t('promotions.page.term.confirm')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

RulesRemarkModal.propTypes = {
  content: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RulesRemarkModal;
